module.exports = __webpack_public_path__ + "static/media/logo-jej@2x.f9adef93.png";